var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "show",
          rawName: "v-show",
          value: this.show,
          expression: "this.show",
        },
      ],
    },
    [
      _c("div", {
        staticClass: "seal-modal",
        on: {
          mousewheel: function ($event) {
            $event.preventDefault()
          },
          click: function ($event) {
            if ($event.target !== $event.currentTarget) {
              return null
            }
            return _vm.close.apply(null, arguments)
          },
        },
      }),
      _vm._v(" "),
      _c("div", { staticClass: "seal-dialog" }, [
        _c("div", { staticClass: "top" }, [
          _c("span", { staticClass: "title" }, [_vm._v("意愿认证")]),
          _vm._v(" "),
          _c("span", { staticClass: "closeIcon", on: { click: _vm.close } }, [
            _vm._v("x"),
          ]),
        ]),
        _vm._v(" "),
        _vm.showLoading
          ? _c("div", { staticClass: "body-modal" }, [
              _c("div", { staticClass: "load-box" }, [
                _c(
                  "svg",
                  {
                    staticStyle: { "enable-background": "new 0 0 50 50" },
                    attrs: {
                      xmlns: "http://www.w3.org/2000/svg",
                      "xmlns:xlink": "http://www.w3.org/1999/xlink",
                      width: "40px",
                      height: "40px",
                      viewBox: "0 0 50 50",
                      "xml:space": "preserve",
                    },
                  },
                  [
                    _c(
                      "path",
                      {
                        attrs: {
                          fill: "#409eff",
                          d: "M43.935,25.145c0-10.318-8.364-18.683-18.683-18.683c-10.318,0-18.683,8.365-18.683,18.683h4.068c0-8.071,6.543-14.615,14.615-14.615c8.072,0,14.615,6.543,14.615,14.615H43.935z",
                          transform: "rotate(275.098 25 25)",
                        },
                      },
                      [
                        _c("animateTransform", {
                          attrs: {
                            attributeType: "xml",
                            attributeName: "transform",
                            type: "rotate",
                            from: "0 25 25",
                            to: "360 25 25",
                            dur: "0.6s",
                            repeatCount: "indefinite",
                          },
                        }),
                      ],
                      1
                    ),
                  ]
                ),
              ]),
            ])
          : _vm._e(),
        _vm._v(" "),
        !_vm.isFinish
          ? _c("div", { staticClass: "body" }, [
              _c("div", { staticClass: "body-title" }, [_vm._v("意愿认证")]),
              _vm._v(" "),
              _vm.type == "phone"
                ? _c("div", [
                    _c("div", { staticClass: "body-content" }, [
                      _c("div", { staticClass: "content-text" }, [
                        _vm._v("手机号"),
                      ]),
                      _vm._v(" "),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.phoneNumber,
                            expression: "phoneNumber",
                          },
                        ],
                        staticClass: "number-input",
                        attrs: { type: "number", disabled: "true" },
                        domProps: { value: _vm.phoneNumber },
                        on: {
                          input: function ($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.phoneNumber = $event.target.value
                          },
                        },
                      }),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "body-content" }, [
                      _c("div", { staticClass: "content-text" }, [
                        _vm._v("验证码"),
                      ]),
                      _vm._v(" "),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.code,
                            expression: "code",
                          },
                        ],
                        staticClass: "code-input",
                        attrs: {
                          placeholder: "请输入验证码，必填",
                          type: "text",
                          maxlength: "15",
                        },
                        domProps: { value: _vm.code },
                        on: {
                          input: function ($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.code = $event.target.value
                          },
                        },
                      }),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "code-button",
                          on: { click: _vm.sendMessage },
                        },
                        [
                          _vm._v(
                            "\n            " +
                              _vm._s(_vm.text) +
                              _vm._s(
                                _vm.count > 0 ? "(" + _vm.count + ")" : ""
                              ) +
                              "\n          "
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _vm.noCode
                        ? _c("div", { staticClass: "nocode" }, [
                            _vm._v("请输入验证码"),
                          ])
                        : _vm._e(),
                    ]),
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.type == "password"
                ? _c("div", [
                    _c("div", { staticClass: "body-content" }, [
                      _c("div", { staticClass: "content-text" }, [
                        _vm._v("签署密码"),
                      ]),
                      _vm._v(" "),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.password,
                            expression: "password",
                          },
                        ],
                        staticClass: "password-input",
                        attrs: {
                          type: "password",
                          placeholder: "请输入签署密码，必填",
                        },
                        domProps: { value: _vm.password },
                        on: {
                          input: function ($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.password = $event.target.value
                          },
                        },
                      }),
                      _vm._v(" "),
                      _vm.noPassword
                        ? _c("div", { staticClass: "nocode" }, [
                            _vm._v("请输入密码"),
                          ])
                        : _vm._e(),
                    ]),
                  ])
                : _vm._e(),
              _vm._v(" "),
              _c(
                "button",
                { staticClass: "comfirm", on: { click: _vm.reComfirm } },
                [_vm._v("确认")]
              ),
              _vm._v(" "),
              _c("div", { staticClass: "body-content" }, [
                _c("span", { staticClass: "ohter" }, [
                  _vm._v("其他认证方式："),
                ]),
                _vm._v(" "),
                _vm.type != "password"
                  ? _c(
                      "span",
                      {
                        staticClass: "comfirm-type",
                        on: {
                          click: function ($event) {
                            return _vm.changeType("password")
                          },
                        },
                      },
                      [_vm._v("密码认证")]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.type != "phone"
                  ? _c(
                      "span",
                      {
                        staticClass: "comfirm-type",
                        on: {
                          click: function ($event) {
                            return _vm.changeType("phone")
                          },
                        },
                      },
                      [_vm._v("短信认证")]
                    )
                  : _vm._e(),
              ]),
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.isFinish
          ? _c("div", { staticClass: "finish-body" }, [
              _vm.isSuccess
                ? _c("div", [
                    _c("div", { staticClass: "check-icon_succ-pp-deal" }),
                    _vm._v(" "),
                    _c("div", { staticClass: "purpose" }, [
                      _vm._v("意愿认证已完成"),
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "check-btn", on: { click: _vm.close } },
                      [
                        _vm._v(
                          "\n          确定" +
                            _vm._s(
                              _vm.number > 0 ? "(" + _vm.number + ")" : ""
                            ) +
                            "\n        "
                        ),
                      ]
                    ),
                  ])
                : _c("div", [
                    _c("div", { staticClass: "check-icon-pp-deal" }),
                    _vm._v(" "),
                    _c("div", { staticClass: "purpose" }, [
                      _vm._v("意愿认证失败"),
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "again-btn",
                        on: { click: _vm.checkagain },
                      },
                      [_vm._v("重新认证")]
                    ),
                  ]),
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm._m(0),
      ]),
    ]
  )
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "foot" }, [
      _c("div", { staticClass: "foot-contain" }, [
        _c("div", { staticClass: "icon" }),
        _vm._v(" "),
        _c("span", [_vm._v("本次认证服务由e签宝提供")]),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }